import { kebabCase } from 'lodash-es';
import I18n from 'utils/I18n';
import { ACTIONS } from '../components/ActionButton/ActionButton';
import { CATEGORIES, REGISTRATION_FLOW } from './onboardingConstants';

export const t = (key, params) =>
  I18n.t(`components.onboarding.${key}`, { ...params });

export const stepToUrl = ({ category, step }) => {
  const prefix = category === CATEGORIES.consents ? '/athlete' : '';
  return `${prefix}/${category}/${kebabCase(step)}`;
};

export const analyticsPageName = (page) => {
  if (page === REGISTRATION_FLOW.createProfile) {
    // page name for the initial onboarding step does not match REGISTRATION_FLOW.createProfile
    // See REGISTRATION_FLOW.createProfile
    return 'account_details';
  }
  if (page === REGISTRATION_FLOW.welcome) {
    return 'onboarding_welcome';
  }
  return page;
};

// actions - "denied" and "approved" trigger permissions creation on the backend
export const isConsentsCreateAction = (action) => {
  return [ACTIONS.denied, ACTIONS.approved].includes(action);
};

export default { t, stepToUrl, isConsentsCreateAction };
